import { render, staticRenderFns } from "./ShippingTemplateDialog.vue?vue&type=template&id=0e8e62bc&scoped=true&"
import script from "./ShippingTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./ShippingTemplateDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShippingTemplateDialog.vue?vue&type=style&index=0&id=0e8e62bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8e62bc",
  null
  
)

component.options.__file = "ShippingTemplateDialog.vue"
export default component.exports